import React, { useState, useEffect } from 'react';
import { Button, Row, Col } from 'reactstrap';
import moment from 'moment/moment';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faFilter, faSearch, faCalendar, faRecycle, faBalanceScale } from '@fortawesome/free-solid-svg-icons';
import { useNavigate } from 'react-router-dom';

//Api
import dashboard_api from '../../../api/dashboard_api';

//Components
import TextField from '../../../components/TextField/TextField';
import InfoCard from '../../../components/InfoCard/InfoCard';
import Loading from '../../../components/Loading/Loading';

//Helpers
import { showMessage } from '../../../helpers/message'; 

//Context
import { useDashboard } from 'context/DashboardContext';
import AutosInfracoes from './AutosInfracoes';

//Estado inicial dos filtros
function initialStateFiltros() {
    const dataInicial = new Date();
    const dataFinal = new Date();
    dataInicial.setDate(dataFinal.getDate() - 30);

    return {
        dataInicial: moment(dataInicial).format("YYYY-MM-DD"),
        dataFinal: moment(dataFinal).format("YYYY-MM-DD"),
        prefeituraId: 0,
    }
}

export default function DashBoardGerador() {
    const { dadosDashboardProvider, setDadosDashboardProvider } = useDashboard();

    //Estado de controle do loading na tela
    const [loading, setLoading] = useState(false);

    const navigate = useNavigate();

    //Estado de controle dos dados da dashboard
    const [dadosDashboard, setDadosDashboard] = useState({ numeroColetas: 0, volume: "0,00" });

    //Estado de controle dos valores dos filtros
    const [filtros, setFiltros] = useState(initialStateFiltros());

    //Estado que controlar a exibição da lista dos autos das infrações
    const [visibleAutosInfracoes, setVisibleAutosInfracoes] = useState(false);

    //OnChange para os campos de filtros de datas
    const onChangeFiltros = (e) => {
        const { name, value } = e.target;
        setFiltros({
            ...filtros,
            [name]: value
        })
    }

    //Estado de controle da visibilidade dos filtros
    const [openFiltros, setOpenFiltros] = useState(false);

    //Função que faz a troca do estado da visibilidade dos filtros
    const toggleOpenFiltros = () => { setOpenFiltros(!openFiltros) };

    //Função que carrega ps dadps da dashboard e salva em seu estado
    const carregaDadosDashboard = (buttonFiltro = false) => {
        if(!buttonFiltro && !!dadosDashboardProvider && !!dadosDashboardProvider?.recarregarViaContext){
            setDadosDashboard(dadosDashboardProvider);
            return;
        }  

        setLoading(true);
        const _filtros = { ...filtros };
        _filtros.dataInicial = _filtros.dataInicial + " 00:00:00";
        _filtros.dataFinal = _filtros.dataFinal + " 23:59:59";
        dashboard_api.GetDashboard(_filtros).then(response => {
            response.data.numeroColetas = response.data.numeroColetas.toString();
            setDadosDashboard(response.data);
            setDadosDashboardProvider({...response.data, recarregarViaContext: true});
        }).catch(e => showMessage("Aviso", e.message, "error", null))
            .finally(f => setLoading(false));
    }

    //Carrega os dados da dashboard assim que a tela é carregada
    useEffect(() => {
        carregaDadosDashboard();
    }, []);

    if(visibleAutosInfracoes){
        return <AutosInfracoes
            btnVoltar={() => { 
                carregaDadosDashboard(true);
                setVisibleAutosInfracoes(false);
            }}
        />
    }

    return (
        <div>
            {loading && <Loading />}
            <div className='mt-4 mx-4 d-flex align-items-center justify-content-between'>
                <h4>Totalização de coletas</h4>
                <Button color='primary' onClick={toggleOpenFiltros}><FontAwesomeIcon icon={faFilter} className={"me-2"} /> Filtros</Button>
            </div>
            <div className={`filtros  ${openFiltros ? "" : "close"}`}>
                <Row className='mx-4'>
                    <Col md="12" lg="6">
                        <TextField label={"Inicio"} type={"date"} name={"dataInicial"} value={filtros.dataInicial} onChange={onChangeFiltros} />
                    </Col>
                    <Col md="12" lg="6">
                        <TextField label={"Fim"} type={"date"} name={"dataFinal"} value={filtros.dataFinal} onChange={onChangeFiltros} />
                    </Col>
                    <Col md="12" lg="4" >
                        <Button color='info text-light' className='ms-2' onClick={carregaDadosDashboard}><FontAwesomeIcon className='me-2' icon={faSearch} /> Filtrar</Button>
                    </Col>
                </Row>
            </div>
            <div className='mt-4'>
                <Row className='mx-4'>
                    <Col md="12" lg="6" className='mb-3'>
                        <InfoCard icon={faRecycle} title={"Volume Coletado (litros)"} specialSubTitle={dadosDashboard.volume} />
                    </Col>
                    <Col md="12" lg="6" className='mb-3'>
                        <InfoCard icon={faCalendar} title={"Coletas Realizadas (dias)"} specialSubTitle={dadosDashboard.numeroColetas} />
                    </Col>
                </Row>
            </div>
            <div className='mt-4'> 
                <h4 className='mx-4'>Autos de infração</h4>
                <Row className='mx-4'>
                    <Col md="12" lg="4">
                        <InfoCard 
                            link 
                            icon={faBalanceScale} 
                            onClick={() => {
                                if(dadosDashboard?.quantidadeAutoInfracoes == 0)
                                    return showMessage("Aviso", "Você não tem nenhum auto de infração.", "warning", null);
                                
                                setVisibleAutosInfracoes(true);
                            }} 
                            title={"Quantidade de autos de infração"} 
                            specialSubTitle={dadosDashboard?.quantidadeAutoInfracoes > 0 ? dadosDashboard?.quantidadeAutoInfracoes  : "0"} 
                        />
                    </Col>
                </Row>
            </div>
            
            {dadosDashboard?.notificacoes?.length > 0 &&
                <>
                    <div className='mt-4 mx-4 d-flex align-items-center justify-content-between'>
                        <h4>Notificações</h4>
                    </div>
                    <div className='mt-4'>
                        <Row className='mx-4'>
                            <Col md="12" lg="6" className='mb-3'>
                                <InfoCard  onClick={() => navigate("../notificacoes", { state: { btnVoltar: "/admin/dashboard", tipoNotificacaoParam: "NotificarColetaSemPGRS", titleTable: "Lista de notificações de Coleta sem PGRS" } })} icon={faRecycle} title={"Notificações de Coleta sem PGRS"} specialSubTitle={dadosDashboard?.notificacoes?.length} />
                            </Col>
                        </Row>
                    </div>
                </>
            }
        </div>
    )
}